var context = typeof window === "undefined" ? global : window;
const FLAG_TYPED_ARRAY = "FLAG_TYPED_ARRAY";

export default function parse(jsonStr = '') {
  var _decodedJson = JSON.parse(jsonStr, function (key, value) {
    try {
      if ("flag" in value && value.flag === FLAG_TYPED_ARRAY) {
        return new context[value.constructor](value.data);
      }
    } catch (e) { }

    return value;
  });
  return _decodedJson;
}
